import offsetSlab, { OffsetSlabSection } from '../../../../sections/slabSections/offsetSlab';

export const createLevelOffsetSlabSection = (offsetSlabSurface: number): OffsetSlabSection =>
  offsetSlab({ surface: offsetSlabSurface });
